import React from 'react';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import {
  GripVertical,
  MapPin,
  Link as LinkIcon,
} from 'lucide-react';
import { DIRECTIONS_ORDER_KEY } from '../utils/buttonOrder';
import { productMeta } from '../pages/admin/linksConfig.utils';
import { InfoTip, ProductTileIcon } from './LinksConfigUi';

export default function LinksConfigButtonOrderPanel({
  orderedButtonItems,
  handleButtonOrderDragEnd,
}) {
  return (
                    <section className="fsl-card">
            <div className="fsl-card-head">
              <h2 className="fsl-card-title">
                Ordem dos botões
                <InfoTip text="Controla a sequência dos botões publicados, incluindo produtos, links externos e Como chegar." />
              </h2>
              <span className="fsl-count-chip">{orderedButtonItems.length}</span>
            </div>

            {orderedButtonItems.length > 0 ? (
              <DragDropContext onDragEnd={handleButtonOrderDragEnd}>
                <Droppable droppableId="published-buttons-order">
                  {(dropProvided) => (
                    <div
                      className="fsl-order-list"
                      ref={dropProvided.innerRef}
                      {...dropProvided.droppableProps}
                    >
                      {orderedButtonItems.map((item, index) => {
                        const product = item.product || {};
                        const meta = { ...(productMeta(product.id) || {}), ...product };
                        const label =
                          item.type === 'product'
                            ? product.label || meta.defaultLabel || meta.product
                            : item.type === 'external'
                              ? item.link.label
                              : 'Como chegar';
                        const description =
                          item.type === 'product'
                            ? meta.product || product.product || 'Produto FoodStation'
                            : item.type === 'external'
                              ? 'Link externo'
                              : 'Endereço no Google Maps';

                        return (
                          <Draggable
                            key={item.key}
                            draggableId={`button-${item.key}`}
                            index={index}
                          >
                            {(dragProvided, snapshot) => (
                              <div
                                ref={dragProvided.innerRef}
                                {...dragProvided.draggableProps}
                                className={`fsl-order-row ${snapshot.isDragging ? 'is-dragging' : ''}`}
                                style={dragProvided.draggableProps.style}
                              >
                                <span
                                  className="fsl-drag-handle"
                                  title="Arraste para reordenar"
                                  {...dragProvided.dragHandleProps}
                                >
                                  <GripVertical size={17} strokeWidth={2.4} />
                                </span>
                                <span className={`fsl-order-icon fsl-order-icon--${item.type}`} aria-hidden>
                                  {item.type === 'product' && <ProductTileIcon id={product.id} />}
                                  {item.type === 'external' && (
                                    item.link.image
                                      ? <img src={item.link.image} alt="" />
                                      : <LinkIcon size={17} strokeWidth={2.3} />
                                  )}
                                  {item.key === DIRECTIONS_ORDER_KEY && <MapPin size={17} strokeWidth={2.3} />}
                                </span>
                                <span className="fsl-order-text">
                                  <span className="fsl-order-label">{label}</span>
                                  <span className="fsl-order-desc">{description}</span>
                                </span>
                              </div>
                            )}
                          </Draggable>
                        );
                      })}
                      {dropProvided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            ) : (
              <div className="fsl-order-empty">
                Nenhum botão ativo para ordenar.
              </div>
            )}
          </section>
  );
}
